// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"636":"3ae33780","973":"6d78e571"}[chunkId] + ".chunk.js";
};